var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-play-video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1421.000000, -161.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-play-video",
    transform: "translate(1424.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4457831,15 C31.4457831,24.0814392 24.0814392,31.4457831 15,31.4457831 C5.91856083,31.4457831 -1.44578313,24.0814392 -1.44578313,15 C-1.44578313,5.91856083 5.91856083,-1.44578313 15,-1.44578313 C24.0814392,-1.44578313 31.4457831,5.91856083 31.4457831,15 Z",
    id: "Path",
    strokeOpacity: 0.1,
    stroke: "#090B45",
    strokeWidth: 3,
    fill: "#6F7FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3915663,14.2289157 L11.8554217,7.75301205 C11.5662651,7.57831325 11.186747,7.56626506 10.8915663,7.73493976 C10.5903614,7.90361446 10.4036145,8.22289157 10.4036145,8.56626506 L10.4036145,21.4578313 C10.4036145,21.8012048 10.5903614,22.1204819 10.8855422,22.2891566 C11.0301205,22.3674699 11.186747,22.4096386 11.3493976,22.4096386 C11.5240964,22.4096386 11.6927711,22.3614458 11.8433735,22.2710843 L22.3795181,15.8493976 C22.6626506,15.6807229 22.8373494,15.3674699 22.8373494,15.0421687 C22.8493976,14.7108434 22.6746988,14.3975904 22.3915663,14.2289157 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayVideo);
export default __webpack_public_path__ + "static/media/icon-play-video.b3d2aa718d4b0ebe8b8167ea8d72783f.svg";
export { ForwardRef as ReactComponent };